import { AppDataLocalTax } from '@scts/app-data';
import { ContactSg, Loader, PageHeaderSg } from '@scts-ui/component-library';
import { useTitleService, replaceDevLinkWithConfig } from '@scts/utilities';
import { useEffect, useState } from 'react';
import { FRONT_DOOR_URL, STORAGE_ACCOUNT } from '../../../config';

export const ContactUs = () => {
  const [updated, setUpdated] = useState(false);
  useTitleService('Contact Us: Local Taxation Chamber');

  useEffect(() => {
    if (FRONT_DOOR_URL !== undefined && STORAGE_ACCOUNT) {
      //dev/test different from pp/pa
      AppDataLocalTax.contact.publicHolidayLink = replaceDevLinkWithConfig(
        FRONT_DOOR_URL,
        STORAGE_ACCOUNT,
        AppDataLocalTax.contact.publicHolidayLink
      );
      setUpdated(true);
    }
  }, [FRONT_DOOR_URL, STORAGE_ACCOUNT]);

  return (
    <div className="contact-wrapper">
      <PageHeaderSg headerText={'Contact'} />

      {!updated && <Loader loadingText={''} padding={''} />}
      {updated && (
        <>
          <ContactSg
            address={AppDataLocalTax.contact.address}
            orginisationName={AppDataLocalTax.contact.orginisationName}
            email={AppDataLocalTax.contact.email}
            phone={AppDataLocalTax.contact.phone}
            phoneText={AppDataLocalTax.contact.phoneText}
            publicHolidayLink={AppDataLocalTax.contact.publicHolidayLink}
            publicHolidayText={AppDataLocalTax.contact.publicHolidayText}
            complaints={AppDataLocalTax.contact.complaints}
          />
          <p>The purpose of Tribunals Operations is to provide administrative support to the Scottish Tribunals.</p>
          <p>Users should expect our administration teams to be respectful, polite and helpful at all times.  We will explain our processes clearly, be fair and impartial and provide an efficient and effective service.</p>
          <p>In return, we expect our staff to be treated with respect.  Any incident in which an employee is abused or threatened will not be tolerated.  This includes the serious and persistent use of verbal abuse, aggressive tone and/or foul language.</p>
          <p>More information can be found in our <a target="blank" href="https://www.scotcourts.gov.uk/media/xcmllz1h/214-tribunals-customer-charter-leaflet-v7-july-2024.pdf">User Charter.</a></p>
        </>
      )}
    </div>
  );
};

export default ContactUs;
